import { useTranslation } from 'react-i18next';

import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';

import Modal, {
	ModalBackground,
	ModalContent,
} from '../../../kakapo-ui-kit/components/modals/Modal';
import ModalHeader from '../../../kakapo-ui-kit/components/modals/ModalHeader';
import ThankYouModal from '../../../kakapo-ui-kit/components/modals/ThankYouModal';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';

export function ComplimentCreateThankYouWithID(props: { userID: string }) {
	const query = graphql.useUserQuery({ variables: { id: props.userID } });

	return query.data ? <ComplimentCreateThankYou user={query.data.user as graphql.User} /> : null;
}

const ComplimentCreateThankYou = ({ user }: { user: graphql.User }) => {
	const { t } = useTranslation();
	const history = useHistory();
	const returnUrl = `/feedback/compliments`;

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader returnUrl={returnUrl}>
					<SectionTitle>{t('compliments.thankYou.title')}</SectionTitle>
				</ModalHeader>

				<ModalContent>
					<ThankYouModal
						contentMarginTop={-4}
						contentMarginBottom={-2}
						title={t('compliments.thankYou.description', { firstName: user.firstName })}
						buttonTitle={t('compliments.thankYou.backButton.title', { firstName: user.firstName })}
						videoSrc="/images/ThankYouReward.webm"
						onClick={() => {
							history.push(returnUrl);
						}}
					/>
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
};

export default ComplimentCreateThankYou;
